// @flow

import React from 'react';
import { formatTime, formatDollars, formatDollarsPerHour } from 'clark-utils';

import { Container, Data, Label } from './styles';

type DataType = 'currency' | 'time' | 'rate' | 'status';

type CalculatedPropsType = {
  description: string,
  type: DataType,
  data: number,
};

type DataConversionFnType = (input: number) => string;

type LookupType = { [key: DataType]: DataConversionFnType };

const CONVERSION_LOOKUP: LookupType = {
  time: formatTime,
  currency: formatDollars,
  rate: formatDollarsPerHour,
};

type PropsType = {
  description: string,
  data: string,
};

export const DataHighlight = ({ description, data }: PropsType) => (
  <Container>
    <Label>{description}</Label>
    <Data>{data}</Data>
  </Container>
);

const CalculatedDataHighlight = ({ description, type, data }: CalculatedPropsType) => (
  <DataHighlight description={description} data={CONVERSION_LOOKUP[type](data)} />
);

export default CalculatedDataHighlight;



// WEBPACK FOOTER //
// ./src/components/data-highlight/index.js